// extracted by mini-css-extract-plugin
export default {"override":"XEQBbLLHFcOC2MgyvKip"};